import _ from 'lodash'

export default {
  name: 'profile',

  data: function () {
    return {
      units: 'metric',

      languages: [
        {
          language: 'English',
          codes: ['en_UK', 'en']

        },
        {
          language: 'German',
          codes: ['de_DE', 'de']
        }
      ],
      languageSelected: null
    }
  },

  watch: {

    /**
     *
     */
    languageSelected: function () {
      if (this.languageSelected) {
        // console.log(this.languageSelected)

        // let user = this.$store.getters.getUser
        // user.language = this.languageSelected.codes[0]

        // this.updateUserData(user)

        this.$store.commit('setUserHomeLanguage', this.languageSelected.codes[1])
      }
    }
  },

  computed: {},

  methods: {

    /**
     * Updates user data
     * @param user
     */
    updateUserData: function (user) {
      this.$store.commit('setUser', user)
    },

    /**
     *
     * @param userLang
     */
    selectUserLanguage: function (userLang) {
      for (let lang of this.languages) {
        // console.log(lang.language)
        if (_.includes(lang.codes, this.$store.getters.getUserHomeLanguage)) {
          this.languageSelected = lang
          // console.log('A', lang.language)
          return
        }

        if (_.includes(lang.codes, userLang)) {
          // console.log(lang.codes, userLang)
          this.languageSelected = lang
          // console.log('B', lang.language)
        }
      }
    }
  },

  beforeCreate: function () {
    this.$http.get('v1/ondusapi/profile', {
      headers: {
        'Authorization': 'Bearer ' + this.$store.getters.getAccessToken
      },
      params: {
        state_token: this.$store.getters.getStateToken
      },
      credentials: 'include'
    })
    // success callback
      .then(response => {
        // get body data
        if (response && response.body) {
          // update user data
          this.updateUserData(response.body)

          this.selectUserLanguage(response.body.language)
        }
      })
      // error callback
      .catch(err => {
        this.$manageError(err)
      })
  }

}



// WEBPACK FOOTER //
// ./src/components/profile/profile.js